
import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { get } from 'lodash';
import { getMessage } from 'util/locale';

// components
import Date from 'planting-plan-form/Date';

var baseString = 'vra-advanced-planting-date';
var classString = classNames({
  [`${baseString}`]: true,
  'vra-planting-plan-form__fieldset': true,
  'vra-planting-plan-form__fieldset--date': true,
  'vra-planting-plan-form-inputs': true
});
const PlantingDate = ({
  isAppMode,
  isReviewScriptStep,
  maxDate,
  minDate,
  onSelectDate,
  selectedDate,
  validationResult
}) => {
  if (isReviewScriptStep) { return null; }

  const dateValidations = get(validationResult, 'date');

  return (
    <section className={classString}>
      <Date
        headerText={getMessage('title-text__planting-date')}
        isAppMode={isAppMode}
        maxDate={maxDate}
        minDate={minDate}
        onSelectDate={onSelectDate}
        selected={selectedDate}
        validationResult={dateValidations}
      />
    </section>
  );
};

PlantingDate.propTypes = {
  isAppMode: propTypes.bool.isRequired,
  isReviewScriptStep: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onSelectDate: propTypes.func.isRequired,
  selectedDate: propTypes.string.isRequired,
  validationResult: propTypes.object
};
export default PlantingDate;
